export const CheckMarkIcon = ({className}: {className?: string}) => (
	<svg
		fill="none"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path
			d="M20 6L9 17l-5-5"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
		/>
	</svg>
);
